var json = require('./src/json');
var form = require('./src/form');
var field = require('./src/field');
var nameSchema = require('./src/name-schema');

module.exports = {
    type: field.type,
    get: field.val,
    set: field.val,
    val: field.val,
    getForm: form.getForm,
    setForm: form.setForm,
    param2json: json.param2json,
    name2element: nameSchema.name2element,
    matchExpression: nameSchema.matchExpression
};